/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatManagementGetTokenResponse } from './ChatManagementGetTokenResponse';

export type ChatManagementGetTokenResponseApiRespoonse = {
    data?: ChatManagementGetTokenResponse;
    status?: ChatManagementGetTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ChatManagementGetTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

